var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.407 19.089"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 121",
    d: "M0 6.89h16.407V-12.2H0z",
    transform: "translate(0 12.199)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 223",
    clipPath: "url(#user_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 221"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 119",
    d: "M12.741 8.371a5.319 5.319 0 00.828-2.851A5.375 5.375 0 008.199.156a5.375 5.375 0 00-5.36 5.364 5.305 5.305 0 00.828 2.851c-1.477.43-3.51 1.886-3.51 6.654a3.752 3.752 0 003.572 3.907h8.95a3.752 3.752 0 003.572-3.907c0-4.768-2.033-6.223-3.51-6.654M8.199 1.495a4.026 4.026 0 014.029 4.025 4.026 4.026 0 01-4.029 4.025 4.025 4.025 0 010-8.05m4.475 16.1H3.729a2.419 2.419 0 01-2.23-2.57c0-3.3 1.113-5.364 3.186-5.469a5.317 5.317 0 003.514 1.328 5.321 5.321 0 003.527-1.328c2.073.1 3.184 2.167 3.184 5.469a2.418 2.418 0 01-2.231 2.568"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 222"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 120",
    d: "M12.741 8.371a5.319 5.319 0 00.828-2.851A5.375 5.375 0 008.199.156a5.375 5.375 0 00-5.36 5.364 5.305 5.305 0 00.828 2.851c-1.477.43-3.51 1.886-3.51 6.654a3.752 3.752 0 003.572 3.907h8.95a3.752 3.752 0 003.572-3.907c0-4.768-2.033-6.219-3.51-6.654zM8.199 1.495a4.026 4.026 0 014.029 4.025 4.026 4.026 0 01-4.029 4.025 4.025 4.025 0 010-8.05zm4.475 16.1H3.729a2.419 2.419 0 01-2.23-2.57c0-3.3 1.113-5.364 3.186-5.469a5.317 5.317 0 003.514 1.328 5.321 5.321 0 003.527-1.328c2.073.1 3.184 2.167 3.184 5.469a2.418 2.418 0 01-2.231 2.568z",
    stroke: "#fff",
    strokeWidth: 0.2
  })))));
}

export default __webpack_public_path__ + "b7ef5d401f0f2bdd49846ad70b699352.svg";
export { SvgUser as ReactComponent };